<template>
	<div id="app">
		<nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark d-print-none">
			<router-link to="/" exact class="navbar-brand">joshefin.xyz</router-link>
			<template v-if="currentUser.email">
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main-navbar" aria-controls="main-navbar" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>
				<div class="collapse navbar-collapse" id="main-navbar">
					<div class="navbar-nav">
						<router-link to="/invoices" exact class="nav-item nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">Fakture</router-link>
						<router-link to="/clients" exact class="nav-item nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">Klijenti</router-link>
						<div class="nav-item dropdown">
	        				<a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">KPO</a>
	        				<div class="dropdown-menu">
	        					<router-link :to="{ path: '/sales/' + year}" exact class="dropdown-item" v-for="year in years" :key="year">{{year}}</router-link>
	        				</div>
	      				</div>
						<router-link to="/settings" exact class="nav-item nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">Podešavanja</router-link>
					</div>
					<div class="navbar-nav ml-auto">
						<div class="nav-item dropdown" v-if="currentUser.email">
							<a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown">
								<i class="material-icons md-18 align-middle">person</i> {{currentUser.email}}
							</a>
	        				<div class="dropdown-menu">
	          					<a class="dropdown-item" href="#" @click="signout">Odjava</a>
	        				</div>
						</div>
					</div>
				</div>
			</template>
		</nav>

		<main>
			<keep-alive>
				<router-view v-if="initialized"></router-view>
			</keep-alive>
		</main>
	</div>
</template>

<script>
import { auth } from './services/firebase';
import { invoiceStore } from './stores/invoices';
import { clientStore } from './stores/clients';
import { settingStore } from './stores/settings';
import moment from 'moment';
import _ from 'lodash';

export default {
	name: 'app',

	data() {
		return {
			initialized: false,
			currentUser: {},
			invoiceState: invoiceStore.state
		};
	},

	computed: {
		years() {
			return this.invoiceState.invoices.filter(i => (i.deliveryDate !== null)).map(i => moment(i.deliveryDate.toDate()).year()).filter((year, index, years) => years.indexOf(year) === index);
		}
	},

	beforeCreate() {
		auth.onAuthStateChanged((user) => {
			this.initialized = true;

			if (user) {
				this.currentUser = {
					email: user.email
				};

				if (this.$route.path === '/signin')
					this.$router.replace('/');
			}
			else {
				this.currentUser = {};

				if (this.$route.path !== '/signin')
					this.$router.replace('/signin');
			}
		});
	},

	watch: {
		currentUser(user) {
			if (!_.isEmpty(user))
				this.init();
			else
				this.destroy();
		}
	},

	methods: {
		init() {
			clientStore.init()
				.catch((error) => {
					this.$toasted.error('Nije uspelo učitavanje klijenata. ' + error.toString(), {
						icon: 'error_outline'
					});
				});

			settingStore.init()
				.catch((error) => {
					this.$toasted.error('Nije uspelo učitavanje podešavanja. ' + error.toString(), {
						icon: 'error_outline'
					});
				});

			invoiceStore.init()
				.catch((error) => {
					this.$toasted.error('Nije uspelo učitavanje faktura. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		},

		destroy() {
			clientStore.destroy();
			settingStore.destroy();
			invoiceStore.destroy();
		},

		signout() {
			auth.signOut()
				.catch((error) => {
					this.$toasted.error('Nije uspela odjava. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		}
	}
};
</script>

<style lang="scss">
body {
	padding-top: 3.5rem;
	padding-bottom: 3.5rem;
}

.navbar-brand {
	font-weight: 300;
}

.material-icons {
	vertical-align: text-bottom!important;
}
.material-icons.md-18 {
	font-size: 18px;
}
.material-icons.md-24 {
	font-size: 24px;
}
.material-icons.md-36 {
	font-size: 36px;
}
.material-icons.md-48 {
	font-size: 48px;
}

.toast {
	background-color: #323232 !important;
	font-size: 0.8rem !important;
	font-weight: 400 !important;
	line-height: 1.5 !important;
	padding: 0.75rem 1.25rem !important;

	&.success {
		background-color: #323232 !important;
	}

	&.error {
		background-color: #323232 !important;
	}
}
</style>



// WEBPACK FOOTER //
// App.vue?9eae4c74